require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-oauth-tutorial-part-1-setting-facebook.json") })
        }
      }, "path---post-oauth-tutorial-part-1-setting-facebook");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-oauth-tutorial-part-1-setting-facebook!./.cache/json/post-oauth-tutorial-part-1-setting-facebook.json
// module id = 346
// module chunks = 231608221292675